import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from "./components/Header";
import Main from "./components/Main";
import WhatsApp from "./components/WhatsApp";
import Footer from "./components/Footer";
import SuiteJacuzziPage from "./pages/SuiteJacuzziPage";
import CamerePage from "./pages/CamerePage";
import ColazioneePage from "./pages/ColazioneePage";
import DoveSiamoPage from "./pages/DoveSiamoPage";
import { LanguageProvider } from './context/LanguageContext';

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <div className="App">
                    <Header />
                    <Routes>
                        <Route path="/" element={<Main />} />
                        <Route path="/suite-jacuzzi" element={<SuiteJacuzziPage />} />
                        <Route path="/camere" element={<CamerePage />} />
                        <Route path="/colazione" element={<ColazioneePage />} />
                        <Route path="/dove-siamo" element={<DoveSiamoPage />} />
                    </Routes>
                    <WhatsApp />
                    <Footer />
                </div>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
